/* All expored functions here assume docuemnt is already loaded, so to avoid working with promises */

/* Elements */
let bodyEl

/* Private functions */
const getBodyEl = () => document.querySelector('body')

/* Export functions */
export const getBaseHref = () => getBodyEl().dataset.baseHref
